if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      connectedCallback() {
        if (!this.dataset.currency) return;
        this.unitPrice = Number(this.dataset.unitPrice);
        this.priceFormatter = new Intl.NumberFormat(this.dataset.locale, {
          style: "currency", currency: this.dataset.currency, currencyDisplay: "narrowSymbol",
        });
        this.updateButtonPrice = () => {
          const quantity = Math.max(parseInt(this.form.querySelector('[name="quantity"]')?.value, 10) || 1, 1);
          this.querySelectorAll("[data-atc-price]").forEach((element) => {
            element.textContent = "- " + this.priceFormatter.format(this.unitPrice * quantity / 100);
          });
        };
        this.form.addEventListener("input", this.updateButtonPrice);
        this.form.addEventListener("change", this.updateButtonPrice);
        this.priceVariantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== this.dataset.sectionId || !event.data.variant) return;
          this.unitPrice = event.data.variant.price;
          this.updateButtonPrice();
        });
        this.priceQuantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.updateButtonPrice);
        this.updateButtonPrice();
      }

      disconnectedCallback() {
        this.priceVariantUnsubscribe?.();
        this.priceQuantityUnsubscribe?.();
        if (this.updateButtonPrice) {
          this.form.removeEventListener("input", this.updateButtonPrice);
          this.form.removeEventListener("change", this.updateButtonPrice);
        }
      }

      onSubmitHandler(evt) {
        if (window.LinkedProductNavigation?.isLoading && this.closest('.product__info-container, pdp-sticky-bar')) {
          evt.preventDefault();
          return;
        }
        evt.preventDefault();
        if (this.closest("pdp-sticky-bar")) {
          const primaryProductForm = document.querySelector(".product__info-container product-form");
          const primaryButton = primaryProductForm?.querySelector('button[name="add"]:not(.product-form__submit--mobile)');
          if (primaryProductForm && primaryButton) {
            if (!primaryButton.disabled && primaryButton.getAttribute("aria-disabled") !== "true") {
              primaryProductForm.onSubmitHandler(evt);
            }
            return;
          }
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const alternateAddToCartButton = document.querySelector(
          ".add-to-cart--alternate"
        );
        if (alternateAddToCartButton) {
          alternateAddToCartButton.setAttribute("aria-disabled", true);
          alternateAddToCartButton.classList.add("loading");
          alternateAddToCartButton
            .querySelector(".loading__spinner")
            .classList.remove("hidden");
          alternateAddToCartButton
            .querySelector("span")
            .classList.add("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const mainVariantId = formData.get("id");
        const mainQuantity = formData.get("quantity") || "1";
        const extraItems = [];
        document.querySelectorAll("[data-atc-contributor]").forEach((contributor) => {
          if (typeof contributor.getCartItems !== "function") return;
          if (!(contributor.dataset.variantIds || "").split(",").includes(String(mainVariantId))) return;
          extraItems.push(...contributor.getCartItems(mainQuantity));
        });
        if (extraItems.length && !formData.has("properties[__shopify_send_gift_card_to_recipient]")) {
          extraItems.push({ id: mainVariantId, quantity: mainQuantity });
          const originalEntries = Array.from(formData.entries());
          formData.delete("id");
          formData.delete("quantity");
          extraItems.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
            Object.entries(item.properties || {}).forEach(([key, value]) => {
              formData.append(`items[${index}][properties][${key}]`, value);
            });
            if (index === extraItems.length - 1) {
              originalEntries.forEach(([key, value]) => {
                if (key.startsWith("properties[") || key === "selling_plan") {
                  formData.delete(key);
                  const itemKey = key === "selling_plan"
                    ? `items[${index}][selling_plan]`
                    : `items[${index}][properties][${key.slice(11, -1)}]`;
                  formData.append(itemKey, value);
                }
              });
            }
          });
        }
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } 
            
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    //this.cart.renderContents(response);
                     openCartDrawer();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              //this.cart.renderContents(response);
              if (typeof openCartDrawer === 'function') {
                openCartDrawer();
              }
            }
          })
          .catch((e) => {
            console.error(e);
            // A rejected response does not mean Shopify rejected the add.
            // Read the cart through the drawer; never repeat the POST here.
            this.handleErrorMessage("We couldn’t confirm the cart update. Check your cart before adding again.");
            if (typeof openCartDrawer === "function") openCartDrawer();
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            if (alternateAddToCartButton) {
              alternateAddToCartButton.classList.remove("loading");
              alternateAddToCartButton.removeAttribute("aria-disabled");
              alternateAddToCartButton
                .querySelector("span")
                .classList.remove("hidden");
              alternateAddToCartButton
                .querySelector(".loading__spinner")
                .classList.add("hidden");
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
